import React from 'react';
import Markdown from 'react-markdown';
import { useTranslation } from 'react-i18next';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

function DegreeReq(props) {
  const { t } = useTranslation();
  const { requirements } = { ...props };

  return (
    <>
      <hr className="degree-req-horizontal-line" />
      <h3 className="req-section-title">{t('Admission Requirements:')}</h3>
      {requirements.includes('</') ? (
        <div className="degree-req">
          <Markdown rehypePlugins={[rehypeRaw, rehypeSanitize]}>
            {requirements.replace(/“|”/gi, '"').trim()}
          </Markdown>
        </div>
      ) : (
        <div className="degree-req">{requirements}</div>
      )}
      <hr className="degree-req-horizontal-line" />
    </>
  );
}

export default DegreeReq;
